// Foundations
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';

// Services
import { MyProfileService } from '../../../services/my-profile.service';
import { PackageService } from '../../../services/package.service';

// Components
import { PackageItem } from '../../../models/package/package-item.model';

// Models
import { OrderRequestItem } from 'src/app/models/package/order-request.model';

import * as lodash from 'lodash';

@Component({
  selector: 'app-package-list',
  templateUrl: './package-list.component.html',
  styleUrls: ['./package-list.component.scss'],
})
export class PackageListComponent implements OnInit, OnDestroy {
  // #region -> Property - IO <-
  // ----------

  @Input() orderRequest$: Observable<OrderRequestItem>;
  orderRequest: OrderRequestItem = new OrderRequestItem({});
  orderRequestSubscription: Subscription;
  @Output() orderRequestChange = new EventEmitter<OrderRequestItem>();

  @Input() packageList$: Observable<PackageItem[]>;
  packageList: PackageItem[] = [];
  packageListSubscription: Subscription;

  @Output() changeStep = new EventEmitter<number>();

  // If the "selected location" has enabled CCP (Credit Card Processing).
  isCcpEnabledInLocation = false;

  // ----------
  // #endregion

  /////////////////////////////

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private packageService: PackageService,
    private myProfileService: MyProfileService
  ) {}

  // #region -> Lifecycle <-
  // ----------

  ngOnInit(): void {
    //
    this.packageListSubscription = this.packageList$.subscribe(
      (newPackageList) => {
        // Empty the list if the incoming data is empty
        if (lodash.isEmpty(newPackageList)) {
          this.packageList = [];
        } else {
          // this.packageList = [...this.packageList, ...newPackageList];
          this.packageList = [...newPackageList];
        }

        // Update the package list
        if (!lodash.isEmpty(this.orderRequest)) {
          //
          this._updatePackageList();
        }

        // Trigger change detection when mutated.
        this.changeDetectorRef.markForCheck();
      }
    );
    this.orderRequestSubscription = this.orderRequest$.subscribe(
      (newOrderRequest) => {
        this.orderRequest = this.orderRequest.update({
          ...newOrderRequest.json(),
        });

        // Check the "CCP Enabled" flag
        if (this.orderRequest.selectedLocation) {
          this.isCcpEnabledInLocation = this.myProfileService.isCcpEnabled(
            this.orderRequest.selectedLocation
          );
        }

        // Update the package list
        if (!lodash.isEmpty(this.orderRequest)) {
          //
          this._updatePackageList();
        }

        // Trigger change detection when mutated.
        this.changeDetectorRef.markForCheck();
      }
    );
  }

  ngOnDestroy(): void {
    //
    this.packageListSubscription.unsubscribe();
    this.orderRequestSubscription.unsubscribe();
  }

  // ----------
  // #endregion

  /////////////////////////////

  // Public Methods
  // ------------------------------------------------------------------------------------

  get isPreferredLocation() {
    if (
      this.orderRequest.selectedLocation &&
      this.packageService.preferredLocation
    ) {
      return (
        this.orderRequest.selectedLocation.id ===
        this.packageService.preferredLocation.id
      );
    }

    return false;
  }

  handleEditLocation(): void {
    this.changeStep.emit(1);
  }

  hasNoSelection(): boolean {
    let result = true;
    this.packageList.forEach((packageItem) => {
      if (packageItem.isSelected) {
        result = false;
      }
    });
    return result;
  }

  togglePackageSelection(packageItem: PackageItem): void {
    //
    if (packageItem.isSelected) {
      // About to de-select
      this.orderRequest = this.orderRequest.removePackage(packageItem);
    } else {
      // About to select
      this.orderRequest = this.orderRequest.addNewPackage(packageItem);
    }

    // Update the package list
    this._updatePackageList();

    //
    this.changeDetectorRef.detectChanges();
  }

  proceed() {
    // Send the updated "order request"
    this.orderRequestChange.emit(this.orderRequest);
    //
    this.changeStep.emit(3);
  }

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Private Method <-
  // ----------

  private _updatePackageList() {
    this.packageList.forEach((packageItem) => {
      if (this.orderRequest.includePackage(packageItem)) {
        //
        packageItem.isSelected = true;
      } else {
        //
        packageItem.isSelected = false;
      }
    });
  }

  // ----------
  // #endregion

  /////////////////////////////
}
